import i18next from 'i18next'

export const adTypesBadges: AdTypesLabels = {
  banner: { color: 'success', label: i18next.t(`rm:Banner`) },
  banner_video: { color: 'successSolid', label: i18next.t(`rm:banner_video`) },
  product: { color: 'warning', label: i18next.t(`rm:productAds`) },
  sponsored_brand: {
    color: 'primary',
    label: i18next.t(`rm:sponsoredBrand`)
  },
  sponsored_brand_video: {
    color: 'primaryDark',
    label: i18next.t(`rm:sponsoredBrandVideo`)
  },
  digital_signage: {
    color: 'info',
    label: i18next.t(`rm:digitalSignage`)
  },
  banner_off_site: {
    color: 'success',
    label: i18next.t(`rm:bannerOffsite`)
  }
}
